module.exports = __webpack_public_path__ + "static/media/tf.ab4296aa.svg";